const defaultTexts = {
    error: 'Error',
    connectionError: 'Connection error',
    ok: 'OK',
    restart: 'Restart'
};

export { defaultTexts };